import React, { useId, type CSSProperties } from "react";

/**
 * Brand loading indicator — same concept as zenpost-frontend's DS Loader:
 * ZenPost mark with a soft floating pulse + cyan glow, optional message.
 */
export function BrandLoader({
  message,
  size = 56,
}: {
  message?: string;
  size?: number;
}) {
  const gid = useId();
  return (
    <div className="brand-loader" role="status" aria-live="polite" aria-label={message ?? "Loading"}>
      <span className="brand-loader__mark" style={{ "--loader-size": `${size}px` } as CSSProperties}>
        <svg
          className="brand-loader__svg"
          width={size}
          height={size}
          viewBox="6 0 108 108"
          aria-hidden="true"
        >
          <defs>
            <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="var(--purple)" />
              <stop offset="100%" stopColor="var(--cyan)" />
            </linearGradient>
          </defs>
          <g fill={`url(#${gid})`}>
            <circle cx="60" cy="26" r="12.5" />
            <path fillRule="evenodd" d="M28 46 A 32 22 0 0 0 92 46 L 75 46 A 17 11 0 0 1 45 46 Z" />
            <path d="M60 79 C 51 65 28 66 28 79 C 28 92 51 93 60 79 C 69 65 92 66 92 79 C 92 92 69 93 60 79 Z" />
          </g>
        </svg>
      </span>
      {message ? <p className="brand-loader__message">{message}</p> : null}
    </div>
  );
}
